export var MilestonesVisualTypes;(function (MilestonesVisualTypes) {MilestonesVisualTypes["VERTICAL"] = "vertical";})(MilestonesVisualTypes || (MilestonesVisualTypes = {}));



export var MilestoneStatuses;(function (MilestoneStatuses) {MilestoneStatuses["INACTIVE"] = "inactive";MilestoneStatuses["ACTIVE"] = "active";MilestoneStatuses["COMPLETED"] = "completed";})(MilestoneStatuses || (MilestoneStatuses = {}));
//# sourceMappingURL=Milestones.js.map